import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { VehicleDamageActivityEventHydration } from './vehicle-damage-activity-event-hydration.dto';

/**
 * A vehicle damage activity event with hydrated related records.
 */
export class VehicleDamageActivityEventDto extends ActivityEventDto {
  hydrated?: VehicleDamageActivityEventHydration;
}
